import { Create, SimpleForm, useCreate, useRedirect, useNotify } from "react-admin";
import { useMemo, useState } from "react";
import SaveForm from "./SaveForm";
import { PAID } from "utils/constants";
import { candidateRequests } from "api/candidateApi";
import { useLocation } from "react-router-dom";
import CustomToolbar from "../components/CustomToolbar";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreatePaidCampaign = () => {
  const location = useLocation();
  const isClone = location?.state?.isClone;
  const [create] = useCreate();
  const redirect = useRedirect();
  const notify = useNotify();

  const [isSaving, setIsSaving] = useState(false);

  const defaultValues = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const source = params.get("source");
    if (source) {
      try {
        return JSON.parse(decodeURIComponent(source));
      } catch (e) {
        console.error("Invalid source:", e);
      }
    }
    return {};
  }, [location.search]);

  const campaignSave = data => {
    setIsSaving(true);
    create(
      candidateRequests.campaignByType(PAID),
      { data },
      {
        onSuccess: () => {
          redirect("list", candidateRequests.campaignByType(PAID));
        },
        onError: error => {
          console.error(error);
          notify(`Error: ${error.message || "Грешка при създаване на платена кампания"}`, { type: "error" });
          setIsSaving(false);
        },
      },
    );
  };

  return (
    <Create
      title={isClone ? "Клониране на платена кампания" : "Създаване на платена кампания"}
      actions={<BackButtonToolbar />}
    >
      <SimpleForm
        onSubmit={campaignSave}
        defaultValues={defaultValues}
        toolbar={<CustomToolbar isSaving={isSaving} />}
      >
        <SaveForm isClone={isClone} />
      </SimpleForm>
    </Create>
  );
};
export default CreatePaidCampaign;
